import React, { useState } from 'react'
import { LayersTree } from '../LayersTree'
import { useFlag } from '@sketch/modules-common'
import * as S from './CanvasLeftPanel.styles'
import { useForTablet, ResizeHandle } from '@sketch/components'
import { useCanvasLeftPanelResizing } from './CanvasLeftPanelResizingContext'

type CanvasLeftPanelProps = {
  isInspectPanelOpen: boolean
  navigationComponent: React.ReactNode
}

/**
 * Floating panel on the left of the canvas containing the small page/frames selector
 * and, if in inspect mode, the layers tree.
 */
export function CanvasLeftPanel({
  isInspectPanelOpen,
  navigationComponent: selectorComponent,
}: CanvasLeftPanelProps) {
  const [hideLayersTree, setHideLayersTree] = useState(false)
  const inspectorTreeFlag = useFlag('inspect-layers-tree')
  const isTabletAndBigger = useForTablet()

  /** true if the layers tree feature is enabled, could still be hidden */
  const hasLayersTree =
    isInspectPanelOpen && inspectorTreeFlag && isTabletAndBigger

  const { width, isResizing, resizeHandleRef } = useCanvasLeftPanelResizing()

  return (
    <S.CanvasLeftPanel
      style={hasLayersTree ? { width } : undefined}
      $isResizing={isResizing}
    >
      {hasLayersTree && <ResizeHandle ref={resizeHandleRef} />}
      <S.CanvasLeftPanelHeader $isResizing={isResizing}>
        <S.SelectorContainer>{selectorComponent}</S.SelectorContainer>
        {hasLayersTree && (
          <S.ToggleLayersTreeContainer>
            <S.ToggleLayersTreeButtonDivider />
            <S.ToggleLayersTreeButton
              $isActive={!hideLayersTree}
              onClick={() => setHideLayersTree(prev => !prev)}
            >
              <S.ToggleLayersTreeButtonIcon />
            </S.ToggleLayersTreeButton>
          </S.ToggleLayersTreeContainer>
        )}
      </S.CanvasLeftPanelHeader>
      {hasLayersTree && !hideLayersTree && (
        <S.LayersTreeContainer $isResizing={isResizing}>
          <LayersTree />
        </S.LayersTreeContainer>
      )}
    </S.CanvasLeftPanel>
  )
}
